module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/close-48791bda9f972c517d2fc8cc88a33524.svg";